//
// Autogenerated by Thrift Compiler (0.13.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require('thrift');
var Thrift = thrift.Thrift;
var Q = thrift.Q;
var Int64 = require('node-int64');


var ttypes = module.exports = {};
ttypes.REGISTER_STATUS = {
  'USERNAME_IS_OCCUPIED' : 0,
  'USERNAME_LENGTH_ERROR' : 1,
  'USERNAME_OK' : 2,
  'USERNAME_IS_EMPTY' : 3,
  'EMAIL_IS_OCCUPIED' : 4,
  'EMAIL_INVALID' : 5,
  'EMAIL_TOO_LONG' : 6,
  'EMAIL_OK' : 7,
  'PASSWORD_WRONG' : 8,
  'PASSWORD_OK' : 9,
  'REGISTRATION_IS_SUCCEED' : 10,
  'REGISTRATION_IS_FAILED' : 11,
  'UNKNOWN_RESULT' : 12
};
ttypes.ENTER_STATUS = {
  'SUCCESS' : 0,
  'FAILED' : 1
};
ttypes.AUTH_SERVICE_NAME = 'authService';
